var app = angular.module("nms.dynamicDevice");

app.directive("contentHeader",
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/content-header.html"
        };
    }
);
